<div class="step-two-col">
  <div class="step-col-main">
    <meeting-completed></meeting-completed>
  </div>
  <div class="step-col-report">
    <report></report>
  </div>
</div>